module.exports = __webpack_public_path__ + "TrapsAndTrinkets.webp?0d270edbec8067d05814c44ba13c30bb";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/TrapsAndTrinkets.webp
// module id = 167
// module chunks = 0